import tools from  "@/public/tools.js"
export default {
	getSmtquoteOn(state){
		return state.smtQuoteOn;
	},
	//获取首单免费提示语
	getFirstTips(state){
		return state.hasFirstTips;
	},
	getQuotepcbSize(state){
		return state.pcbSize;
	},
	getQuoteArea(state){
		return state.area;
	},
	getQuoteExpressList(state){		
		return state.expressList;
	},
	getQuoteValuation(state){
		return state.valuation;
	},
	getQuotepcb_params(state){
		return tools.assign(state.pcb_params);
	},
	getQuotepcb_high_params(state){
		return tools.assign(state.pcb_high_params);
	},
	getQuotefpc_params(state){
		return tools.assign(state.fpc_params);
	},
	getQuoterfpc_params(state){
		return tools.assign(state.rfpc_params);
	},
	getQuotesmt_params(state){
		return tools.assign(state.smt_params);
	},
	getQuotesmd_params(state){
		return tools.assign(state.smd_params);
	},
	getQuoteAsideParams(state){
		return tools.assign(state.aside_param);
	},
	getQuoteParams(state,getters, rootState){
		let	params = {},aside_param = state.aside_param,relation = state.relation;	
		const fpc_params = state.fpc_params
		let pcbSize = state.pcbSize;
		//serve
		if(state.stay !== "bom"){ 
			params = tools.assign(params,aside_param);			
		} else {
			let bom_params = state.bom_params;	
				params = tools.assign(params,bom_params);
		}			
		//獲取需要計價的參數
		if(state.stay == "pcb" || relation == "pcb"){
			let pcb_params = state.pcb_params;	
				params = tools.assign(params,pcb_params);
				params.service = "pcb";
			//處理隱藏的參數
			for(let k in state.pcb_hideparams){
				if(!state.pcb_hideparams[k]){
					//设置参数传值 为空还是为0
					if(k == "blind" || k == "impendance" || k == "beveledge" || k == "bankong" || k == "review_file" || k == "shipment_report" || k == "slice_report" || k == "insidecopper"){						
						params[k] = 0;
					}else if(k == "via_in_pad"){
						params[k] = "N/A";
					}else if(k == "period_format"){
						params[k] = undefined;
					} else if(k == "pcscount"){
						params[k] = 2;
					} else{
						params[k] = "";
					}					
				}				
			}
			//gerberview
			if(!params.pcbfile){
				params.pcbfile = undefined;
			}
			if(!params.pid){
				params.pid = undefined;
			}

			// FR-4时 清空铝基板参数
			if (params.plate_type === "Fr-4") {
				const delField = [
					'thermalc', 'rogers', 'plug_in_holes'
				]

				for(let i in params) {
					if (delField.includes(i)) {
						delete params[i]
					}
				}

			}

			// 铝基板时 清空FR-4参数
			if (params.plate_type === "Aluminum") {
				const delField = [
					'blind', 'board_tg', 'insidecopper', 'cover', 'beveledge',
					'impendance', 'bankong', 'baobian', 'has_period', 'film_report'
				]

				for(let i in params) {
					if (delField.includes(i)) {
						delete params[i]
					}
				}

			}

			if (params.plate_type !== 'Rogers') {
				delete params.rogers
			}

			params.via_in_pad = 'N/A'
		}
		/*
		if(state.stay == "smt"){
			
		} */
		if(state.stay == "smd"){
			//1,當前在fpc頁面
			let smd_params = state.smd_params;				
				params = tools.assign(smd_params,params);
				params.service = "stencil";
			//處理隱藏的參數
			if(params.fpc_blayer < 2){
				params.impendance = undefined;
			}
		}
		if(state.stay == "fpc" || relation == "fpc"){
			//1,當前在fpc頁面
			let fpc_params = state.fpc_params;				
				params = tools.assign(fpc_params,params);
				params.service = "pcb";
			//處理隱藏的參數
			if(params.fpc_blayer < 2){
				params.impendance = undefined;
			}
		}
		if(state.stay == "rfpc" || relation == "rfpc"){
			let rfpc_params = state.rfpc_params;	
				params = tools.assign(rfpc_params,params);
				params.service = "pcb";
			//處理隱藏的參數
			if(params.blayer <= 2){
				params.impendance = undefined;
			}
		}

		// 获取高端板材需要計價的參數
		if(state.stay == "pcb_high" || relation == "pcb_high"){
			let pcb_params = state.pcb_high_params;	
			params = tools.assign(params,pcb_params);
			params.service = "pcb";
			
			//gerberview
			if(!params.pcbfile){
				params.pcbfile = undefined;
			}
			if(!params.pid){
				params.pid = undefined;
			}

			params.via_in_pad = 'N/A'

			params.customField = state.customField
		}
		
		/* 
		params 通用規則 隱藏參數等
		*/
		if(params.blength){
			const { bwidthSum, blengthSum, bwidthSum1, blengthSum1 } = pcbSize
			let max,min, max1,min1,lastWidth,lastLength
	
			if(blengthSum > bwidthSum){
				max = blengthSum;
				min = bwidthSum;
			}else{
				max = bwidthSum;
				min = blengthSum;
			}
			if(blengthSum1 > bwidthSum1){
				max1 = blengthSum1;
				min1 = bwidthSum1;
			}else{
				max1 = bwidthSum1;
				min1 = blengthSum1;
			}
			// 常规PCB
			if(params.level === 1) {
				if (params.plate_type == 'Fr-4') {
					if (params.blayer <= 4) {
						if (max <= 600 && min <= 520) {
							lastWidth = min
							lastLength = max
						} else if (max1 <= 600 && min1 <= 520) {
							lastWidth = min1
							lastLength = max1
						} else {
							lastWidth = pcbSize.bwidthSum
							lastLength = pcbSize.blengthSum
						}
					} else {
						if (max <= 500 && min <= 400) {
							lastWidth = min
							lastLength = max
						} else if (max1 <= 500 && min1 <= 400) {
							lastWidth = min1
							lastLength = max1
						} else {
							lastWidth = pcbSize.bwidthSum
							lastLength = pcbSize.blengthSum
						}
					}

				} else if(['Aluminum', 'Copper'].includes(params.plate_type)) {
					if (max <= 1200 && min <= 540) {
						lastWidth = min
						lastLength = max
					} else if (max1 <= 1200 && min1 <= 540) {
						lastWidth = min1
						lastLength = max1
					} else {
						lastWidth = pcbSize.bwidthSum
						lastLength = pcbSize.blengthSum
					}
				} else if (params.plate_type === 'Flex board' || params.plate_type === 'Rigid-Flex board') {
					if (max <= 1500 && min <= 500) {
						lastWidth = min
						lastLength = max
					} else if (max1 <= 1500 && min1 <= 500) {
						lastWidth = min1
						lastLength = max1
					} else {
						lastWidth = pcbSize.bwidthSum
						lastLength = pcbSize.blengthSum
					}
				} else if (params.plate_type === 'High sample-rate') {
					if (max <= 600 && min <= 500) {
						lastWidth = min
						lastLength = max
					} else if (max1 <= 600 && min1 <= 500) {
						lastWidth = min1
						lastLength = max1
					} else {
						lastWidth = pcbSize.bwidthSum
						lastLength = pcbSize.blengthSum
					}
				} else {
					lastWidth = pcbSize.bwidthSum
					lastLength = pcbSize.blengthSum
				}
			}
			// 高端PCB
			if (params.level === 2) {
				if (max <= 10000 && min <= 10000) {
					lastWidth = min
					lastLength = max
				} else if (max1 <= 10000 && min1 <= 10000) {
					lastWidth = min1
					lastLength = max1
				} else {
					lastWidth = pcbSize.bwidthSum
					lastLength = pcbSize.blengthSum
				}
			}
			params.bwidth = tools.keepDecimal(lastWidth/10,2,true);
			params.blength = tools.keepDecimal(lastLength/10,2,true);

			// 长宽原始值，传给后端
			const initWidth = state.stay == "pcb_high" ? state.pcb_high_params.bwidth : state.pcb_params.bwidth
			const initBlength = state.stay == "pcb_high" ? state.pcb_high_params.blength : state.pcb_params.blength
			params.bwidth_init = tools.keepDecimal(initWidth/10,2,true)
			params.blength_init = tools.keepDecimal(initBlength/10,2,true)
		}
		if(params.units && params.units == 1){
			params.layoutx = 1;
			params.layouty = 1;
		}
		if(params.sidedirection === "N/A"){
			params.sidewidth = 0;
		}
		//insidecopper 小於2曾沒有内層銅厚
		if(params.fpc_blayer <= 2){
			params.fpc_insidecopper = undefined;
		}
		if(params.blayer <= 2){
			params.insidecopper = 0;
		}		
		//2,看是否有關聯訂單
		let relationParams = {};
		if(state.stay == "smt" || relation == "smt"){
			if(relation){
				params.service = tools.quoteServes[state.stay == "smt"?"smt":params.service] +","+ tools.quoteServes[relation];
			}else{
				params.service = tools.quoteServes["smt"]
			}			
			relationParams =  tools.assign(relationParams,state.smt_params);
			//處理隱藏的參數
			for(let k in state.smt_hideparams){
				if(!state.smt_hideparams[k]){
					//设置参数传值 为空还是为0 或者不传
					relationParams[k] = undefined;					
				}				
			}
			//單獨處理pcb_width,pcb_height
			if(relation){
				relationParams.pcb_width = params.bwidth;
				relationParams.pcb_height = params.blength;	
			}else{
				relationParams.pcb_width = relationParams.pcb_width/10;
				relationParams.pcb_height = relationParams.pcb_height/10;	
			}	
			//如果是bom關聯單
			let bom_params = state.bom_params;
			if(bom_params.bom_file_id){
				params.service = params.service + ",bom";
				params = tools.assign(bom_params,params);
			}			
		}		
		if(state.stay == "smd" || relation == "smd"){
			if(relation){
				params.service = tools.quoteServes[state.stay == "smd"?"smd":params.service] +","+ tools.quoteServes[relation];
			}else{
				params.service = tools.quoteServes["smd"]
			}			
			relationParams =  tools.assign(relationParams,state.smd_params);
		}
		if(state.stay == "bom"){
			params.service = tools.quoteServes["bom"];
		}

		//根據新需求，儅fpc，rfpc關聯smt時，custom_pcb_ban 值為1
		let rstParams = tools.assign(params,relationParams);
		if(relation){
			if(rstParams.custom_pcb_ban && (relation=="fpc" || relation=="rfpc" || state.stay == "fpc" || state.stay == "rfpc")){
				rstParams.custom_pcb_ban = rstParams.custom_pcb_ban2;
				if(relation){
					rstParams.custom_pcb_ban = 2;
				}
			}
		}

		// smt活动时带上key,使购物车选中 Free Assembly for 5 pieces 活动
		if(state.isSmtActivity){
			rstParams.activity_code='pcba_assembly_less_fifty_pcs'
		}

		const { isChangeParams, changeParams } = rootState
		if (isChangeParams) {
			rstParams.order_id = changeParams.order_id
		}

		// FPC
		if (rstParams.plate_type === 'Flex board') {
			rstParams = tools.assign(rstParams, fpc_params)
			rstParams.blayer = ''
		}

		if (rstParams.plate_type === 'Rigid-Flex board') {
			rstParams = tools.assign(rstParams, fpc_params)
		}
		
		return rstParams;
	},
	isQuoteParamsOk(state){
		return function(key){
			return state.canQuote[key];
		}
	},
	getisCalcBtn(state){
		return state.isCalcBtn
	},
	ajaxQuoteParams(state){
		return state.ajaxQuoteParams;
	},
	isValuationing(state){
		return state.isValuationing
	},
	getStepPrice(state){
		return state.stepPrice
	},
	getIsStepClick(state){
		return state.isStepClick
	}
}